import styled from "styled-components";
import { ColorProps, GlobalColorPalette } from "@gago/frame";

// tslint:disable:variable-name
export const VideoListBody = styled.div<ColorProps<GlobalColorPalette>>`
  height: 100%;
  width: 100%;
  padding: 16px 140px 24px;
  background-color: #161616;
  .video-box{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .video-item{
      flex: 1 1 auto;
      width: 45%;
      height: 426px;
      margin-right: 12px;
      margin-top: 12px;
      &:nth-of-type(2n){
        margin-right: 0px;
      }
    }
  }
  .pagain-box{
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    .ant-pagination-prev, .ant-pagination-next, .ant-pagination-jump-prev, .ant-pagination-jump-next {
      font-weight: 400;
      font-size:16px;
      font-family:MicrosoftYaHei;
      color: #00cae0;
    }
    .ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link {
      border-color: #00cae0;
      background-color: #122B45;
      .anticon svg {
        color: #00cae0;
      }
    }
    .ant-pagination-item {
      border-color: #00cae0;
      background-color: #122B45;
      font-weight: 400;
      font-size:16px;
      font-family:MicrosoftYaHei;
      color: #00cae0;
      a {
        color: #00cae0;
      }
      &.ant-pagination-item-active {
        background-color: #122B45;
        border-color: #c2fffa;
        font-weight: 400;
        font-size:16px;
        font-family:MicrosoftYaHei;
        color: #c2fffa;
        a {
          font-size:16px;
          font-family:MicrosoftYaHei;
          color: #c2fffa;
        }
      }
    }
    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
      color: #c2fffa;
    }
    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
      color: #c2fffa;
    }
    .ant-pagination-disabled{
      .ant-pagination-item-link{
        border-color: #122B45;
        .anticon svg {
          color: #3e84c9;
        }
      }
    }
  }
`;
